import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { ActivityItem, ActivityState } from './types';

const initialState: ActivityState = {
  items: [],
  hasMore: true,
  offset: 0,
  isLoading: false,
  error: null,
};

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    fetchActivityRequest(
      state,
      _action: PayloadAction<{ offset: number; limit: number }>,
    ) {
      state.isLoading = true;
      state.error = null;
    },

    fetchActivitySuccess(
      state,
      action: PayloadAction<{ items: ActivityItem[]; limit: number }>,
    ) {
      state.isLoading = false;
      state.items.push(...action.payload.items);
      state.offset = state.items.length;
      if (action.payload.items.length < action.payload.limit) {
        state.hasMore = false;
      }
    },

    fetchActivityFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetActivity(state) {
      state.items = [];
      state.hasMore = true;
      state.offset = 0;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const activityActions = activitySlice.actions;
export const activityReducer = activitySlice.reducer;
